module.exports = __webpack_public_path__ + "static/media/wp_4.d0e7ee6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_4.png
// module id = 33
// module chunks = 0